export var DbStatsTable;
(function (DbStatsTable) {
    DbStatsTable["COMPANY"] = "company";
    DbStatsTable["COVERAGE"] = "coverage";
    DbStatsTable["GROUP"] = "group";
    DbStatsTable["SUBSCRIPTION"] = "subscription";
})(DbStatsTable || (DbStatsTable = {}));
